<template>
  <w-modal
    v-model="show"
    :submitButton="$t('buttons.close')"
    :title="title"
    :showCloseButton="false"
    :closeOnSubmit="true"
    :hideOnOverlay="true"
    :hideOnEsc="true"
    @submit="$emit('close')"
    @close="$emit('close')"
  >
    <div class="row" v-if="stateData">
      <div class="form-group col-12">
        <span class="label">{{ $t('text.medicalExaminationPreviewModal.deliveredTeam') }}</span
        >{{ stateData.team.name }}
      </div>

      <div class="form-group col-12">
        <span class="label">{{ $t('text.medicalExaminationPreviewModal.expirationDate') }}</span
        >{{ stateData.end | moment('DD-MM-Y') }}
      </div>

      <div class="form-group col-12">
        <span class="label">{{ $t('text.medicalExaminationPreviewModal.description') }}</span>

        <p class="scroll-text" v-html="stateData.description"></p>
      </div>
    </div>
  </w-modal>
</template>

<script>
import WModal from '@witkac/bootstrap4-components/src/components/modal.vue';
import { mapState } from 'vuex';

import { previewManageMixin } from '@/mixins/previewManage';

// @vuese
// Modal wyświetlający treść badania lekarskiego
// @group Components
export default {
  components: { WModal },
  mixins: [previewManageMixin('profile/medicalExamination')],
  computed: {
    ...mapState({
      stateData: state => state.profile.medicalExamination.data
    }),
    title() {
      return this.stateData ? this.stateData.name : '';
    }
  }
};
</script>
